import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { RatesFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkRatesPOSTErrorResponse, ParkRatesPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchRates = async (): Promise<ParkRatesPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkRatesPOSTSuccessResponse>("/rates");
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkRatesPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: RatesFailReason };
  }
};
